import {useHierarchyNavAccess} from '@domain/kpis'
import {Grid} from '@mui/material'
import {
  AreaDashboardContainer,
  AreaFilterContainer,
  type AreaNavigation,
  useMapMarkersData
} from '@widgets/area-dashboard'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE, SHIFT_QUICK_SELECT_SLOTS_OPTIMIZATION_SPECIALIST} from '../consts'
import {AreaOptimizationSpecialistCardContainer} from '../containers'

type Props = {
  dashboardRoute: string
  navigation: AreaNavigation
  fallbackBreadcrumbs?: React.ReactNode
  useMapMarkersDataHook?: typeof useMapMarkersData
}

export const OptimizationSpecialistAreaDashboard = ({
  dashboardRoute,
  navigation,
  fallbackBreadcrumbs,
  useMapMarkersDataHook = useMapMarkersData
}: Props) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const {allowedAreas, getAreaById} = useHierarchyNavAccess(
    'VIEW_OPTIMIZATION_SPECIALIST_DASHBOARD'
  )

  return (
    <AreaDashboardContainer
      dashboardTitle={t('areaDashboard.pageTitle')}
      dashboardRoute={dashboardRoute}
      navigation={navigation}
      permission="VIEW_OPTIMIZATION_SPECIALIST_DASHBOARD"
      useMapMarkersDataHook={useMapMarkersDataHook}
      useAccessHook={useHierarchyNavAccess}
      allowedAreas={allowedAreas}
      getAreaById={getAreaById}
      fallbackBreadcrumbs={fallbackBreadcrumbs}
      getPlantCards={(args: PlantCardsListProps) => (
        <PlantCardsList {...args} getPlantLink={navigation.getPlantLink} />
      )}
      headerActionContent={
        <AreaFilterContainer
          quickSelectSlots={SHIFT_QUICK_SELECT_SLOTS_OPTIMIZATION_SPECIALIST}
          defaultSlot="pastShift"
        />
      }
    />
  )
}

type PlantCardsListProps = {
  plantIds: string[]
  spacing?: number
  columnsCount?: number
  kpiGridItemXs?: number
}

const COLUMN_SIZE = 1

const PlantCardsList = ({
  plantIds,
  getPlantLink,
  spacing = 2,
  columnsCount = 1,
  kpiGridItemXs = 4
}: PlantCardsListProps & {getPlantLink: AreaNavigation['getPlantLink']}) => {
  return (
    <Grid container spacing={spacing} columns={columnsCount * COLUMN_SIZE}>
      {plantIds.map((plantId) => {
        return (
          <Grid key={plantId} item xs={COLUMN_SIZE}>
            <AreaOptimizationSpecialistCardContainer
              plantId={plantId}
              plantLink={getPlantLink(plantId)}
              cardBoxSx={{width: '100%'}}
              kpiGridItemXs={kpiGridItemXs}
            />
          </Grid>
        )
      })}
    </Grid>
  )
}
